import React from "react";
import { useT } from "@/i18n";
import { PageHeader } from "@/components/common/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PaymentsTab } from "./PaymentsTab";
import { SettlementsTab } from "./SettlementsTab";
import { BillingTab } from "./BillingTab";
import { PurchasesTab } from "./PurchasesTab";
import { CarteraTab } from "./CarteraTab";

export default function FinancePage() {
  const { t } = useT();
  return (
    <>
      <PageHeader testId="finance-page-header" title={t("finance.title")} subtitle={t("finance.subtitle")} />
      <div className="flex-1 overflow-y-auto p-6" data-testid="finance-page">
        <Tabs defaultValue="payments">
          <TabsList data-testid="finance-tabs">
            <TabsTrigger data-testid="finance-tab-payments" value="payments">{t("finance.tabs.payments")}</TabsTrigger>
            <TabsTrigger data-testid="finance-tab-settlements" value="settlements">{t("finance.tabs.settlements")}</TabsTrigger>
            <TabsTrigger data-testid="finance-tab-billing" value="billing">{t("finance.tabs.billing")}</TabsTrigger>
            <TabsTrigger data-testid="finance-tab-purchases" value="purchases">{t("finance.tabs.purchases")}</TabsTrigger>
            <TabsTrigger data-testid="finance-tab-cartera" value="cartera">{t("finance.tabs.cartera")}</TabsTrigger>
          </TabsList>
          <TabsContent value="payments"><PaymentsTab /></TabsContent>
          <TabsContent value="settlements"><SettlementsTab /></TabsContent>
          <TabsContent value="billing"><BillingTab /></TabsContent>
          <TabsContent value="purchases"><PurchasesTab /></TabsContent>
          <TabsContent value="cartera"><CarteraTab /></TabsContent>
        </Tabs>
      </div>
    </>
  );
}
